import React from 'react';
import { Col } from 'bootstrap';
import EventFolderListBreadCrumb from 'shared/components/event/folderListBreadcrumb';

// eslint-disable-next-line react/prop-types
const BreadcrumbBar = ({ teamId, eventId, content }) => {
  content = content || <EventFolderListBreadCrumb {...{ teamId, eventId }} />;

  return (
    <Col lg={24} className="hidden-xs event-folder-breadcrumb-bar">
      <Col lgOffset={1} lg={23}>
        {content}
      </Col>
    </Col>
  );
};

export default BreadcrumbBar;
